import { defineStore } from 'pinia';

export const useExamFilterStore = defineStore('examFilter', {
  state: () => ({
    filter: {
      newRequest: false,
      examCurrentPage: 0,
      shouldCloseFilter: false,
      filter: {
        startDate: null,
        endDate: null,
        userOffset: null,
        patientID: null,
        patientFullName: null,
        ffsFilter: 'all',
        reportStatusFilter: 'all',
        properties: {
          mcRas: false,
          color: false,
          redfree: false,
          infrared: false,
          segAnterior: false,
          panoramic: false,
          stereo: false
        }
      }
    }
  }),
  actions: {
    refreshFilter(newFilterData) {
      this.filter.newRequest = newFilterData.newRequest !== undefined ? newFilterData.newRequest : this.filter.newRequest;
      this.filter.examCurrentPage = newFilterData.examCurrentPage !== undefined ? newFilterData.examCurrentPage : this.filter.examCurrentPage;
      this.filter.shouldCloseFilter = newFilterData.shouldCloseFilter !== undefined ? newFilterData.shouldCloseFilter : this.filter.shouldCloseFilter;

      if (newFilterData.filter) {
        const currentInnerFilter = this.filter.filter;
        const incomingInnerFilter = newFilterData.filter;

        this.filter.filter = {
          startDate: incomingInnerFilter.startDate !== undefined ? incomingInnerFilter.startDate : currentInnerFilter.startDate,
          endDate: incomingInnerFilter.endDate !== undefined ? incomingInnerFilter.endDate : currentInnerFilter.endDate,
          userOffset: incomingInnerFilter.userOffset !== undefined ? incomingInnerFilter.userOffset : currentInnerFilter.userOffset,
          patientID: incomingInnerFilter.patientID !== undefined ? incomingInnerFilter.patientID : currentInnerFilter.patientID,
          patientFullName: incomingInnerFilter.patientFullName !== undefined ? incomingInnerFilter.patientFullName : currentInnerFilter.patientFullName,
          filterSelected: incomingInnerFilter.filterSelected !== undefined ? incomingInnerFilter.filterSelected : currentInnerFilter.filterSelected,
          ffsFilter: incomingInnerFilter.ffsFilter !== undefined ? incomingInnerFilter.ffsFilter : currentInnerFilter.ffsFilter,
          reportStatusFilter: incomingInnerFilter.reportStatusFilter !== undefined ? incomingInnerFilter.reportStatusFilter : currentInnerFilter.reportStatusFilter,

          properties: _.merge({}, currentInnerFilter.properties, incomingInnerFilter.properties || {})
        };
      }
    },

    reset(resetScrollPosition) {
      this.filter = {
        newRequest: false,
        examCurrentPage: 0,
        shouldCloseFilter: false,
        filter: {
          startDate: null,
          endDate: null,
          userOffset: null,
          patientID: null,
          patientFullName: null,
          ffsFilter: 'all',
          reportStatusFilter: 'all',
          properties: {
            mcRas: false,
            color: false,
            redfree: false,
            infrared: false,
            segAnterior: false,
            panoramic: false,
            stereo: false
         }
       }
      }
    },

    closeFilterExplicitly() {
      this.filter.shouldCloseFilter = true
    }
  },
});
